<template>
  <panel title="批发客户情况" :infoContents="infoContents" class="mgb10">
    <template v-slot:right>
      <span
        v-if="records.length != recordsAll.length"
        class="blue"
        @click="showMore"
        >查看更多</span
      >
    </template>

    <vxe-table
      :data="records"
      border
      size="small"
      :loading="loading"
      class="border-inner-top"
      auto-resize
      highlight-hover-row
      :scroll-y="{ enabled: false }"
    >
      <vxe-table-column field="customerName" title="客户"></vxe-table-column>
      <vxe-table-column
        field="todayBargainQty"
        title="今天订单量"
      ></vxe-table-column>
      <vxe-table-column
        field="todayDeliverQty"
        title="今天出货量"
      ></vxe-table-column>
      <vxe-table-column
        field="monthBargainQty"
        title="本月订单量"
      ></vxe-table-column>
      <vxe-table-column
        field="monthDeliverQty"
        title="本月出货量"
      ></vxe-table-column>
      <template v-slot:empty>
        <p>暂无数据</p>
      </template>
    </vxe-table>
  </panel>
</template>
<script>
import Bargain from "@/api/bargain.js";
export default {
  data() {
    return {
      loading: false,
      records: [],
      recordsAll: [],
      infoContents: [
        "订单量：以订单项的创建日期统计 订单条数",
        "出货量：以发货单的创建日期统计 订单项的数量和",
      ],
    };
  },
  created() {
    const self = this;
    self.loading = true;
    Bargain.wholesaleCustomerCount().then(function (res) {
      if (res.status == 200) {
        self.recordsAll = res.data;
        if (res.data.length > 10) {
          self.records = res.data.slice(0, 10);
        } else {
          self.records = res.data;
        }
      } else {
        self.sysError();
      }
      self.loading = false;
    });
  },
  methods: {
    showMore() {
      this.records = this.recordsAll;
    },
  },
};
</script>